import React, { useEffect, useState } from "react";
import ItemManagement from "../components/itemManagement";
import * as swInspectionAction from "../../../../redux/storm-water/actions/swInspectionAction";
import { useDispatch, useSelector } from "react-redux";
import {
  API_STATUS,
  MODULES_NAME,
  ORG_ID,
  PAGE_SIZE,
  SW3RD_PARTY_INSPECTOR,
  SW_CLIENT_MANAGER,
  USER_ID,
} from "../../../../constant/constant";
import { getFormatedDate } from "../../../../utils/helper";
import Loader from "../../../../library/common/Loader";
import { ToastContainer, toast } from "react-toastify";
import { checkPrivileges, hasAllPrivileges } from "../../../../utils/rolesHelper";
import * as assetsAction from "../../../../redux/actions/assetsAction";
import { useLocation, useNavigate } from "react-router-dom";
import * as swCommonAction from "../../../../redux/storm-water/actions/swCommonAction";
import * as clientAction from "../../../../redux/actions/clientAction";
import { ACCESS_DENIED } from "../../../../constant/routeContant";

const ItemManagementContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [timeRange, setTimeRange] = useState(1);
  const [calculatedDate, setCalculatedDate] = useState(new Date());
  const [cartType, setCartType] = useState(1);
  const [selectionModel, setSelectionModel] = useState();
  const [commentBox, setCommentBox] = useState(false);
  const [closeBox, setCloseBox] = useState(false);
  const [disbled, setDisbled] = useState(false);
  const [clearComment, setClearComment] = useState(false);
  const [clearClosed, setClearClosed] = useState(false);
  const todayDate = new Date();
  const [selectedRows, setSelectedRows] = useState([]);
  const adminView = checkPrivileges([12, 105]);
  const CHECK_PRE =
    hasAllPrivileges(SW_CLIENT_MANAGER) ||
    hasAllPrivileges(SW3RD_PARTY_INSPECTOR);

  const location = useLocation();
  const stateData = location?.state;
  const [clients, setClients] = useState();
  const [currentSearch, setCurrentSearch] = useState("");
  const [currentProjectId, setCurrentProjectId] = useState(0);
  const [currentProjectObj, setCurrentProjectObj] = useState(null);
  const refData = {
    flags: [9],
  };
  const getSwReference = useSelector((state) => state.getSwReference);
  const getSwReferenceData = (data) => {
    dispatch(swCommonAction.getSwReference(data));
  };
  const searchAllClientsReducerData = useSelector(
    (state) => state.searchAllClientsReducerData,
  );
  const autoSearchDataLoading = searchAllClientsReducerData.isLoading;
  useEffect(() => {
    getSwReferenceData(refData);
  }, []);

  useEffect(() => {
    if (timeRange != 1) {
      const days = parseInt(timeRange);
      const today = new Date();
      const calculated = new Date(today);
      calculated.setDate(today.getDate() - (days - 1));
      setCalculatedDate(calculated);
    }
    if (timeRange == 1) {
      setCalculatedDate("");
    }
  }, [timeRange]);

  const defaultData = {
    organisationId: clients ? clients : parseInt(ORG_ID()),
    cartType: cartType,
    search: "",
    projectId: currentProjectId ? currentProjectId : 0,
    userId: CHECK_PRE
      ? ""
      : stateData?.userId
        ? stateData?.userId
        : adminView
          ? ""
          : parseInt(USER_ID()),
    fromDate: calculatedDate !== "" ? getFormatedDate(calculatedDate) : "",
    toDate: getFormatedDate(todayDate),
    page: 1,
    pageSize: PAGE_SIZE,
    isTeamTask: stateData?.isTeamTask,
  };
  const commentIntialState = {
    comment: "",
  };
  // uat deploy
  const closeIntialState = {
    dateClosed: todayDate,
    actionTaken: "",
    closedId: "",
    closedIdValue: "",
  };
  const [commentFormValue, setCommentFormValue] = useState(commentIntialState);
  const [closeFormValue, setCloseFormValue] = useState(closeIntialState);
  const [isClosedIdError, setIsClosedIdError] = useState(false);
  const openItemList = useSelector((state) => state.swOpenItemList);
  const getOpenItemList = (data) => {
    dispatch(swInspectionAction.getSwOpenItemList(data));
  };
  const createSwInspectionCloseItem = useSelector(
    (state) => state.createSwInspectionCloseItem,
  );
  const createSwInspectionCloseItemData = (data) => {
    dispatch(swInspectionAction.createSwInspectionCloseItem(data));
  };

  const createSwInspectionItemComment = useSelector(
    (state) => state.createSwInspectionItemComment,
  );
  const createSwInspectionItemCommentData = (data) => {
    dispatch(swInspectionAction.createSwInspectionItemComment(data));
  };

  const isLoading = useSelector((state) => state.swOpenItemList?.isLoading);

  const showLoader = useSelector(
    (state) =>
      state.createSwInspectionCloseItem.isLoading ||
      state.createSwInspectionItemComment.isLoading,
  );

  function handleAllProjectSearch(event, value) {
    dispatch(
      assetsAction.getAssetDynomoList({
        searchText: event.target.value,
        type: 5,
        orgId: clients
          ? clients
          : stateData?.customerId
            ? stateData?.customerId
            : parseInt(ORG_ID()),
      }),
    );
  }

  const allProject = useSelector((state) => state.getAssetDynomoList);
  const isProjectLoading = allProject?.isLoading;

  const handleTimeRangeSetChange = (e) => {
    setTimeRange(e.target.value);
  };

  const getItemHander = (id) => {
    setCartType(id);
  };

  const openItemHandler = (value) => {
    const closevalue = getSwReference?.data?.ItemClosedActionList?.find(
      (item) => item.key === value,
    );
    setCloseFormValue({
      ...closeFormValue,
      closedId: closevalue?.key,
      closedIdValue: closevalue?.value,
    });
  };

  useEffect(() => {
    if ((cartType || calculatedDate) && !stateData) {
      getOpenItemList(defaultData);
    }
  }, [cartType, calculatedDate, stateData]);

  const [closesFilesData, setCloseFilesData] = useState("");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const isMedia = userInfo?.isMediaAllowed;
  const handleFileChange = (files, single) => {
    setCloseFilesData({ fileId: single[0], filePath: files });
  };
  const handleDeleteImageURL = () => {
    setCloseFilesData([]);
  };

  const [isComment, setIsComment] = useState(false);
  function mappedCommentData() {
    let errors = false;
    if (commentFormValue?.comment === "") {
      setIsComment(true);
      errors = true;
    }
    if (errors) {
      return false;
    }

    const data = {
      comment: commentFormValue?.comment,
      userId: parseInt(USER_ID()),
      locationId: selectionModel[0],
    };
    return data;
  }
  const submitCommentData = () => {
    const data = mappedCommentData();
    if (!data) {
    } else {
      setClearComment(true);
      createSwInspectionItemCommentData(data);
    }
  };
  const [isDateClosed, setIsDateClosed] = useState();
  const [isActionTaken, setIsActionTaken] = useState();

  function mappedCloseData() {
    let errors = false;
    if (!closeFormValue?.dateClosed) {
      setIsDateClosed(true);
      errors = true;
    }
    // if (!closeFormValue?.closedId) {
    //   setIsClosedIdError(true);
    //   errors = true;
    // }
    // if (closeFormValue?.actionTaken === "") {
    //   setIsActionTaken(true);
    //   errors = true;
    // }
    if (errors) {
      return false;
    }

    const dataClose = {
      listLocationId: selectionModel,
      dateClosed: getFormatedDate(closeFormValue?.dateClosed),
      actionTaken: closeFormValue?.actionTaken,
      closedId: closeFormValue?.closedId
        ? parseInt(closeFormValue?.closedId)
        : null,
      userId: parseInt(USER_ID()),
      files: [
        {
          fileId: closesFilesData?.fileId ?? 0,
          filePath: closesFilesData?.filePath ?? null,
          subrootId: 0,
        },
      ],
    };
    return dataClose;
  }

  const submitCloseData = () => {
    const dataClose = mappedCloseData();
    if (!dataClose) {
    } else {
      setClearClosed(true);
      createSwInspectionCloseItemData(dataClose);
    }
  };

  useEffect(() => {
    if (selectionModel?.length > 1) {
      setDisbled(true);
    } else {
      setDisbled(false);
    }
  }, [selectionModel]);
  const closeItemHandler = () => {
    setCloseBox(!closeBox);
    setCommentBox(false);
    setCommentFormValue({
      ...commentFormValue,
      comment: "",
    });
  };

  const commentHandler = () => {
    setCloseBox(false);
    setCommentBox(!commentBox);
  };
  const cancelComment = () => {
    setCommentBox(false);
    setCommentFormValue({
      ...commentFormValue,
      comment: "",
    });
  };
  const cancelClose = () => {
    setCloseBox(false);
  };

  useEffect(() => {
    const res = createSwInspectionItemComment?.data?.[0];
    if (res?.responseCode === "HBNG015") {
      toast(res?.responseMessage || "This Client is Inactive");
    }
  }, [createSwInspectionItemComment]);

  useEffect(() => {
    const res = createSwInspectionCloseItem?.data?.[0];
    if (res?.responseCode === "HBNG015") {
      toast(res?.responseMessage || "This Client is Inactive");
    }
  }, [createSwInspectionCloseItem]);

  useEffect(() => {
    if (
      createSwInspectionItemComment.status === API_STATUS.SUCCESS &&
      createSwInspectionItemComment?.data?.[0]?.responseCode !== "HBNG015" &&
      createSwInspectionItemComment?.isLoading === false &&
      clearComment
    ) {
      const currentFilterData = {
        ...defaultData,
        search: currentSearch,
        projectId: currentProjectId,
      };
      getOpenItemList(currentFilterData);
      toast("Comment Added successfully");
      setCommentBox(false);
      setCloseBox(false);
      setCommentFormValue({
        ...commentFormValue,
        comment: "",
      });
      setCloseFormValue({
        ...closeFormValue,
        dateClosed: "",
        actionTaken: "",
      });
      setSelectedRows([]);
      setSelectionModel([]);
    }
  }, [createSwInspectionItemComment]);

  useEffect(() => {
    if (
      createSwInspectionCloseItem.status === API_STATUS.SUCCESS &&
      createSwInspectionCloseItem?.data?.[0]?.responseCode !== "HBNG015" &&
      createSwInspectionCloseItem?.isLoading === false &&
      clearClosed
    ) {
      const currentFilterData = {
        ...defaultData,
        search: currentSearch,
        projectId: currentProjectId,
      };
      getOpenItemList(currentFilterData);
      toast("Closed Item successfully");
      setCloseBox(false);
      setCommentBox(false);
      setCloseFormValue({
        ...closeFormValue,
        dateClosed: "",
        actionTaken: "",
      });
      setCommentFormValue({
        ...commentFormValue,
        comment: "",
      });
      setSelectedRows([]);
      setSelectionModel([]);
    }
  }, [createSwInspectionCloseItem]);

  const handleSelectionModelChange = (selectionModel) => {
    setSelectedRows(
      selectionModel.map((selectedId) =>
        openItemList?.data?.listDetails?.find(
          (row) => row.itemId === selectedId,
        ),
      ),
    );
  };

  useEffect(() => {
    if (selectedRows) {
      const itemIds = selectedRows?.map((item) => item.itemId);
      setSelectionModel(itemIds);
    }
  }, [selectedRows]);
  const searchClient = (searchText) => {
    dispatch(clientAction.searchAllClients(searchText));
  };
  return (
    <>
      {checkPrivileges([12, 105, 106, 107]) ? (
        <>
          {showLoader && <Loader />}
          <ItemManagement
            handleTimeRangeSetChange={handleTimeRangeSetChange}
            timeRange={timeRange}
            openItemList={openItemList?.data ?? []}
            isLoading={isLoading}
            getOpenItemList={getOpenItemList}
            cartType={cartType}
            todayDate={todayDate}
            calculatedDate={calculatedDate}
            getItemHander={getItemHander}
            selectionModel={selectionModel}
            disbled={disbled}
            setSelectionModel={setSelectionModel}
            isComment={isComment}
            commentFormValue={commentFormValue}
            setCommentFormValue={setCommentFormValue}
            submitCommentData={submitCommentData}
            commentBox={commentBox}
            closeBox={closeBox}
            closeItemHandler={closeItemHandler}
            commentHandler={commentHandler}
            cancelComment={cancelComment}
            cancelClose={cancelClose}
            isDateClosed={isDateClosed}
            isActionTaken={isActionTaken}
            closeFormValue={closeFormValue}
            setCloseFormValue={setCloseFormValue}
            submitCloseData={submitCloseData}
            setCartType={setCartType}
            selectedRows={selectedRows}
            handleSelectionModelChange={handleSelectionModelChange}
            handleFileChange={handleFileChange}
            closesFilesData={closesFilesData}
            handleDeleteImageURL={handleDeleteImageURL}
            isMedia={isMedia}
            handleAllProjectSearch={handleAllProjectSearch}
            isProjectLoading={isProjectLoading}
            allProjects={allProject?.data}
            stateData={stateData}
            getSwReference={getSwReference?.data}
            openItemHandler={openItemHandler}
            isClosedIdError={isClosedIdError}
            searchClient={searchClient}
            searchAllClientsReducerData={searchAllClientsReducerData}
            autoSearchDataLoading={autoSearchDataLoading}
            setClients={setClients}
            clients={clients}
            setCurrentSearch={setCurrentSearch}
            setCurrentProjectId={setCurrentProjectId}
            setCurrentProjectObj={setCurrentProjectObj}
            currentProjectObj={currentProjectObj}
          />
          <ToastContainer />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}{" "}
    </>
  );
};

export default ItemManagementContainer;
